<script>
export default {
  name: 'PlusLineIcon',
  props: {
    size: { type: [Number, String], default: 24 },
    color: { type: String, default: 'currentColor' },
  },
}
</script>

<template>
  <!-- "+" isolado, de TRAÇO. O set já tinha sete ícones de "adicionar", mas
       cada um com moldura (`plus` é na verdade `plus-square`, `add-circle` é um
       disco, `more` é um anel). Mesmo contrato de `tune.vue`: stroke uma vez no
       <g>, `fill` como `none` no <svg>. -->
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      :stroke="color"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill="none"
    >
      <path d="M12 5V19" />
      <path d="M5 12H19" />
    </g>
  </svg>
</template>
